export const tabController = (tabName) => {
    const allTabs = document.querySelectorAll('.bPlTabPanel .components-tab-panel__tabs button');
    allTabs.forEach(tab => tab.classList.remove('activeTab'));
    const activeTab = document.querySelector(`.bPlTabPanel .components-tab-panel__tabs button[id$="${tabName}"]`);
    if (activeTab) activeTab.classList.add('activeTab');
};

export const updateObjectAttr = (attr, key, value, setAttributes) => {
    setAttributes({ [attr]: { ...attr, [key]: value } });
};

export const updateArrayItem = (arr, index, updatedItem) =>
    arr.map((item, i) => (i === index ? { ...item, ...updatedItem } : item));

export const removeArrayItem = (arr, index) => arr.filter((_, i) => i !== index);

export const scrollToTop = () => {
    setTimeout(() => {
        const wrapper = document.querySelector('.gmfSiteLayout');
        if (wrapper) {
            wrapper.scrollTo({ top: 0, behavior: 'smooth' });
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 50);
};
